import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Fail.module.css";
import { Helmet } from "react-helmet";

function Fail() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const message = searchParams.get("message");

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Payment Failed - RUSU BD</title>
      </Helmet>
      <div className={styles['fail-page']}>
        <div className={styles['fail-container']}>
          {/* Error Icon */}
          <div className={styles['fail-icon-wrapper']}>
            <div className={styles['fail-icon-circle']}>
              <svg
                className={styles['fail-icon']}
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
          </div>

          {/* Title */}
          <h1 className={styles['fail-title']}>Payment Failed</h1>

          {/* Message */}
          <p className={styles['fail-message']}>
            {message || "Your payment could not be processed. Please try again."}
          </p>

          {/* Info Box */}
          <div className={styles['fail-info-box']}>
            <svg
              className={styles['info-icon']}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
            <div>
              <p className={styles['info-title']}>What happened?</p>
              <p className={styles['info-text']}>
                Your payment was cancelled or declined. No charges have been made to your account.
                Your pending package upgrade has been cleared.
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className={styles['fail-actions']}>
            <button
              className={styles['button-primary']}
              onClick={() => navigate("/billing")}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              Try Again
            </button>
            <button
              className={styles['button-secondary']}
              onClick={() => navigate("/dashboard")}
            >
              Go to Dashboard
            </button>
          </div>

          {/* Support Link */}
          <p className={styles['fail-support']}>
            Need help?{" "}
            <a href="mailto:support@ecomtechbd.com" className={styles['support-link']}>
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default Fail;
